// extracted by mini-css-extract-plugin
export var buttonContainer = "_9b-1";
export var fontSizeSelect = "_9b-3";
export var formatSelect = "_9b-2";
export var formats = "_9b-4";
export var hidden = "_9b-5";
export var icon = "_9b-6";
export var select = "_9b-0";